export default {
  app: ["app"],
  clients: ["clients"],
  user: ["user"],
};



// WEBPACK FOOTER //
// ./src/model/storeShape.js